import { FC } from 'react';
import { EDuplicateEntityType } from 'data/types/duplicateManagement.types';
import DuplicatePairList from '../../components/DuplicatePairList';

const OrganizationsTab: FC = () => (
  <DuplicatePairList entityType={EDuplicateEntityType.ORGANIZATION} />
);

export default OrganizationsTab;
